module.exports = __webpack_public_path__ + "img/catering_menu_5.b3a9f611.jpg";